module.exports = __webpack_public_path__ + "img/banner-2.2264e1ea.png";